import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { TableModule } from './table/table.module';
import { SearchModule } from './search/search.module';
import { TimePickerModule } from './time-picker/time-picker.module';
import { ToggleModule } from './toggle/toggle.module';
import { ToggleLabelledModule } from './toggle-labelled/toggle-labelled.module';
import { ClickOutsideDirective } from './directives/click-outside/click-outside.directive';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation/click-stop-propagation.directive';
import { ModalModule } from './modal/modal.module';
import { DropdownModule } from './dropdown/dropdown.module';
import { InfoTooltipModule } from './info-tooltip/info-tooltip.module';
import { FormInputModule } from './form-input/form-input.module';
import { SliderModule } from './slider/slider.module';
import { ExpandablePanelModule } from './expandable-panel/expandable-panel.module';
import { ProgressBarModule } from './progress-bar/progress-bar.module';
import { ButtonModule } from './button/button.module';
import { AlertModule } from './alert/alert.module';
import { CheckboxModule } from './checkbox/checkbox.module';
import { MapModule } from './map/map.module';
import { SpinnerModule } from './spinner/spinner.module';
import { TooltipModule } from './tooltip/tooltip.module';
import { WizardModule } from './wizard/wizard.module';
import {
    TitleProviderDirective
} from './directives/titleProvider/title-provider.directive';
import {PipesModule} from "./pipes/pipes.module";
import { CustomPopoverDirective } from './directives/popover/custom-popover.directive';
import {CustomPopoverModule} from "./popover/custom-popover.module";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, PopoverModule.forRoot()],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        InfiniteScrollModule,
        TableModule,
        SearchModule,
        TimePickerModule,
        ToggleModule,
        ToggleLabelledModule,
        CheckboxModule,
        ModalModule,
        DropdownModule,
        InfoTooltipModule,
        TooltipModule,
        FormInputModule,
        SliderModule,
        ExpandablePanelModule,
        ProgressBarModule,
        ButtonModule,
        AlertModule,
        MapModule,
        SpinnerModule,
        WizardModule,
        ClickOutsideDirective,
        ClickStopPropagationDirective,
        TitleProviderDirective,
        PipesModule,
        PopoverModule,
        CustomPopoverModule,
        CustomPopoverDirective
    ],
    declarations: [ClickOutsideDirective, ClickStopPropagationDirective, TitleProviderDirective, CustomPopoverDirective]
})
export class SharedModule {}
